import { Subscription, fromEvent } from 'rxjs';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { debounceTime, tap } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';


@Injectable({
  providedIn: 'root',
})
export class DIDService {

  private eventSub: Subscription;
  public socketClientId: string;

  presentationResponse = this.socket.fromEvent<any>('verifier-presentation-response');
  callbackResponse = this.socket.fromEvent<any>('verifier-callback-response');

  issuanceResponse = this.socket.fromEvent<any>('issuer-issuance-response');
  issuanceCallbackResponse = this.socket.fromEvent<any>('issuer-callback-response');

  constructor(private socket: Socket) { 

    this.socketClientId = uuid();
    this.socket.emit('client-connect', this.socketClientId);

    this.eventSub = fromEvent(window, 'visibilitychange').pipe(
      debounceTime(300),
      tap(event => this.visibilitychange(event))
    ).subscribe();
  }

  startVerification(): void {
    this.socket.emit('verifier-presentation-request', this.socketClientId);
  }

  startIssuance(): void {
    this.socket.emit('issuer-issuance-request', {socketClientId: this.socketClientId} );
  }
  startIssuanceMobile(){
    this.socket.emit('issuer-issuance-request', {socketClientId: this.socketClientId})
  }

  visibilitychange(event: any) {

    if(document.hidden) {

      if(this.socket.ioSocket.disconnected){
        return;
      }

      this.socket.disconnect('Page backgrounded');
    }
    else {

      if(this.socket.ioSocket.connected){
        return;
      }

      this.socket.connect();
      this.socket.emit('client-connect', this.socketClientId);
    }
  }
}

